import { Controller } from 'react-hook-form'
import React from 'react'
import { titles, titlesMap } from '../userFormData'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { useUserFormContext } from '../utils/userFormContext'

const Title = () => {
    const { control, setValue, watch } = useFormContextUser()

    const watchedTitle = watch('title')
    const {
        state: { isEditionMode, rppsLocked, isLoading },
    } = useUserFormContext()

    const getTitle = (raw: string | undefined) =>
        raw ? titles.find((option) => option.value.toLowerCase() === raw.toLowerCase()) : undefined

    React.useEffect(() => {
        if (watchedTitle !== undefined) {
            const defaultTitle = watchedTitle || titlesMap.none.value
            setValue('title', isEditionMode ? defaultTitle : watchedTitle)
        }
    }, [isEditionMode, isLoading, setValue, watchedTitle])

    return (
        <Controller
            control={control}
            name="title"
            rules={{
                required: 'Cette information est obligatoire et n’a pas été renseignée',
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="select"
                    type="default"
                    name={field.name}
                    renderLabel={() => getTitle(field.value)?.label}
                    label="Titre *"
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    locked={rppsLocked}
                    placeholder="Choisir"
                    value={field.value || undefined}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    options={titles}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Title
